import Button from './Button';
import Link from './Link';
import Table from './Table';
import List from './List';
import Section from './Section';
import ModalComp from './Modal';

const ComponentsContainer = () => {
    return (
        <div className="components-container">
            <div className="component button-component">
                <div className="component-title">Button</div>
                <Button />
            </div>
            <div className="component link-component">
                <div className="component-title">Link</div>
                <Link />
            </div>
            <div className="component table-component">
                <div className="component-title">Table</div>
                <Table />
            </div>
            <div className="component list-component">
                <div className="component-title">List</div>
                <List />
            </div>
            <div className="component section-component">
                <div className="component-title">Section</div>
                <Section />
            </div>
            <div className="component button-component modal-component">
                <div className="component-title">Modal</div>
                <ModalComp />
            </div>
        </div>
    );
};

export default ComponentsContainer;
